module.exports = __webpack_public_path__ + "img/组 130@2x.9abf117c.png";